import { render } from "./BannerDetail.vue?vue&type=template&id=2d6ae024&scoped=true&ts=true"
import script from "./BannerDetail.vue?vue&type=script&lang=ts"
export * from "./BannerDetail.vue?vue&type=script&lang=ts"

import "./BannerDetail.vue?vue&type=style&index=0&id=2d6ae024&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6ae024"]])

export default __exports__